import type { History } from "history";
import { Store } from "redux";

import geoService from "@mapmycustomers/shared/util/geo/GeoService";

import localSettings from "@app/config/LocalSettings";

import { show as showUserLocationRequest } from "../component/Layout/components/UserLocationRequest/actions";

import configureReduxStore from "./configureReduxStore";
import type { RootState } from "./rootReducer";
import { setStoreRef } from "./storeRef";

/**
 * Holds Redux store to make it possible to use it in
 * regular functions outside of React components.
 */
class ReduxStore {
  // guaranteed to call createStore in /src/index.ts
  private _store!: Store<RootState>;
  private _history!: History;

  createStore(history: History) {
    this._history = history;
    this._store = configureReduxStore(history);
    setStoreRef(this._store);

    geoService.registerErrorHandler("onGeolocationNotAvailable", (e) => {
      if (
        localSettings.isLocationReminderAllowed() &&
        (e?.code === GeolocationPositionError.PERMISSION_DENIED ||
          e?.code === GeolocationPositionError.TIMEOUT)
      ) {
        this._store.dispatch(showUserLocationRequest());
      }
    });
  }

  get history(): History {
    return this._history;
  }

  get store(): Store<RootState> {
    return this._store;
  }
}

const reduxStore = new ReduxStore();
export default reduxStore;
